import { ADD_SUPER_USER_FAILURE, ADD_SUPER_USER_SUCCESS } from "redux/constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case ADD_SUPER_USER_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            };
        case ADD_SUPER_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                errorData: action.payload,
                error: true,
            };
        default:
            return { ...state };
    }
};
